import { FacilityDropdownInput } from "#src/batteries-included-components/Dropdowns/FacilityDropdownInput";
import { useQuery } from "@tanstack/react-query";
import {
  DropdownInput,
  FilterPanel,
  StorageKeys,
  TextInput,
} from "@validereinc/common-components";
import { DeviceAdapter } from "@validereinc/domain";
import { Devices } from "@validereinc/domain-controllers";
import React from "react";

const { DeviceStatusOptions } = Devices.view;

export const DevicesFilterPanel = ({
  filterConfigStorageKey,
}: Pick<StorageKeys, "filterConfigStorageKey">) => {
  const { data: deviceTypes } = useQuery(
    ["device_types"],
    () => DeviceAdapter.types.getList(),
    {
      select: (resp) => resp.data,
    }
  );

  return (
    <FilterPanel
      storageKey={filterConfigStorageKey}
      defaultActiveKeys={["Filters"]}
      filters={[
        {
          component: (
            <TextInput
              name="name"
              key="device-name-filter"
              placeholder="Search Devices..."
              isFluid
              isInline
              type="search"
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              label="Type"
              name="type_id"
              key="device-type-filter"
              options={deviceTypes}
              labelKey="name"
              valueKey="id"
              isFluid
              isMulti
              isOptionalTextShown={false}
              isSortedAlphabetically
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <DropdownInput
              label="Status"
              name="status"
              key="form-template-filter"
              options={DeviceStatusOptions}
              labelKey="label"
              valueKey="value"
              isFluid
              isMulti
              isOptionalTextShown={false}
            />
          ),
        },
        {
          section: "Filters",
          component: (
            <FacilityDropdownInput
              isFluid
              isMulti
              name="facility.id"
            />
          ),
        },
      ]}
    />
  );
};
